import { useMemo } from 'react';
import SanitizedText from 'sanitize-text/components/SanitizedText';
import { View } from 'foundations-components/components/View';
import { useListSharedSalesDocumentsQuery } from '../../__generated__/chirp/com/hubspot/portals/platform/app/rpc/SharedSalesDocumentsRpc.hooks';
import { DOCUMENT_ID_ATTR, personalizeDocumentLinks } from 'deal-plans-lib/utils/personalizeDocumentLinks';
import { jsx as _jsx } from "react/jsx-runtime";
export function DealPlanDescriptionView({
  description,
  dealPlanId
}) {
  const {
    data
  } = useListSharedSalesDocumentsQuery({
    variables: {
      queryObjectTypeId: '0-3366',
      queryObjectId: dealPlanId,
      limit: 100,
      offset: 0
    },
    skip: !description.includes(DOCUMENT_ID_ATTR)
  });
  const body = useMemo(() => {
    var _data$salesDocuments;
    return personalizeDocumentLinks(description, (_data$salesDocuments = data === null || data === void 0 ? void 0 : data.salesDocuments) !== null && _data$salesDocuments !== void 0 ? _data$salesDocuments : []);
  }, [description, data]);
  return /*#__PURE__*/_jsx(View, {
    marginBlockEnd: "600",
    children: /*#__PURE__*/_jsx(SanitizedText, {
      body: body
    })
  });
}